import type { AllCompaniesNames } from '../../types/general';

export const isValidCompanyName = (
  company: string,
  companies: Record<AllCompaniesNames, () => React.JSX.Element>,
): company is AllCompaniesNames => {
  return company in companies;
};
